import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CreateBudget from "./CreateBudget";
import UserService from "services/UserService";
import axios from "axios";
import { getBudgets } from "services/ConfigServices";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import { budgetpagetext } from "variables/budget";
import moment from "moment";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

export default function useBudgetTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const budgetadmin = permis.includes("budget_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById, selectedNodesInfo, groupTypeListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getBudgets(chartIdGroup);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBudgets, setSelectedBudgets] = useState([]);
  console.log(chartIdGroup);
  console.log(selectedNodesInfo);
  console.log(groupTypeListById[''+chartIdGroup[0]]);
  const refreshTable = () => {
    setRefresh(!refresh);
  }

  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `budgets`, []).filter(
    (item) =>
      (item.parameters.name && item.parameters.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.code && item.parameters.code.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.energy && item.parameters.energy.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.perimeter && item.parameters.perimeter.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.idgroup && groupInfoListById["" + item.idgroup] && groupInfoListById["" + item.idgroup].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters.datebegin && moment(item.parameters.datebegin).isValid() && moment(item.parameters.datebegin).format("DD/MM/YYYY").includes(filterText)) ||
      (item.parameters.dateend && moment(item.parameters.dateend).isValid() && moment(item.parameters.dateend).format("DD/MM/YYYY").includes(filterText))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedBudgets.map((item) => {
      let budgettoexport = {};
      budgettoexport[budgetpagetext.general.name] = item.parameters.name;
      budgettoexport[budgetpagetext.general.code] = item.parameters.code || "";
      budgettoexport[budgetpagetext.general.energy] = item.parameters.energy || "";
      budgettoexport[budgetpagetext.general.datebegin] = (item.parameters.datebegin && moment(item.parameters.datebegin).isValid()) ? moment(item.parameters.datebegin).format("DD/MM/YYYY") : "";
      budgettoexport[budgetpagetext.general.dateend] = (item.parameters.dateend && moment(item.parameters.dateend).isValid()) ? moment(item.parameters.dateend).format("DD/MM/YYYY") : "";
      budgettoexport[budgetpagetext.general.amount] = item.parameters.amount || "";
      budgettoexport[budgetpagetext.general.account] = (item.idgroup && groupInfoListById["" + item.idgroup]) ? groupInfoListById["" + item.idgroup] : "";
      budgettoexport[budgetpagetext.general.perimeter] = item.parameters.perimeter || "";
      return budgettoexport;
    });

    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {budgetadmin && chartIdGroup && (groupTypeListById[''+chartIdGroup[0]]==='4.0') && (
          <UploadButton type="button" onClick={handleClear}>
            <CreateBudget refetch={refreshTable} onClick={handleClear} />
          </UploadButton>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedBudgets || selectedBudgets.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedBudgets, chartIdGroup]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refreshTable,
    setSelectedBudgets
  };
}
